import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'

const fetchInfo = async () => {
  return await apiHelperService.get(`/api/individual/info`)
}
const getFamilyMembers = async () => {
  const formStore = useFormStore()
  return await apiHelperService.post(`/api/individual/citizen/getFamilyBookMembers`, {
    familyMemberIdn: formStore.draft.request.identityNumber
  })
}

const initInfo = async () => {
  const formStore = useFormStore()
  const res = await fetchInfo()
  const {
    nationalityId,
    englishFullName,
    arabicFullName,
    identityNumber,
    familyBookNumber,
    familySequence,
    arabicFatherName,
    arabicFirstName,
    arabicFourthName,
    arabicGrandName,
    englishFourthName,
    englishGrandName,
    faithId,
    professionId,
    religionId,
    passportNumber,
    unifiedNumber,
    englishFatherName,
    englishFirstName
  } = res

  formStore.draft.request = {
    ...formStore.draft.request,
    ...{
      applicantCurNationalityId: nationalityId,
      applicantEngFullName: englishFullName,
      applicantArbFullName: arabicFullName,
      applicantIdentityNumber: identityNumber,
      identityNumber: identityNumber,
      familyNumber: familyBookNumber,
      familyBooKFamilySequence: familySequence,
      applicantArbFatherName: arabicFatherName,
      applicantArbFirstName: arabicFirstName,
      applicantArbFourthName: arabicFourthName,
      applicantArbThirdName: arabicGrandName,
      applicantEngFourthName: englishFourthName,
      applicantEngThirdName: englishGrandName,
      applicantFaithId: faithId,
      applicantProfessionId: professionId,
      applicantReligionId: religionId,
      arabicName: arabicFullName,
      englishName: englishFullName,
      localPassportNumber: passportNumber,
      personUnifiedNumber: unifiedNumber,
      sponsorNumber: unifiedNumber,
      applicantEngFatherName: englishFatherName,
      applicantEngFirstName: englishFirstName
    }
  }
}

export default async function () {
  const formStore = useFormStore()

  try {
    formStore.extraMap = {}
    await initInfo()
    const response = await getFamilyMembers()
    if (response && response?.collection?.length > 0) {
      const details = response.collection[0]
      formStore.draft.request = {
        ...formStore.draft.request,
        ...{
          familyBookCityCode: details.cityCode,
          oldMaritalStatusId: details.maritalStatusId
        }
      }
    }
  } catch (error) {
    console.error('use762Preload', error)
  }
}
